import React, { useState } from 'react';
import { UserCircle, Settings, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const routeToLogin = () => {
    localStorage.removeItem('token');  
    navigate('/login');
  };
  const routeTohome = () => {
    navigate('/home')
  }
  const getUserFullName = () => {
    const user = localStorage.getItem('user_name') ;
    return user;
  }
  return (
    <header className="w-full h-16 bg-neutral-900 border-b border-neutral-800 px-6 flex items-center justify-between fixed top-0 left-0 z-50 shadow-sm">
      {/* Logo + Title */}
      <div className="flex items-center space-x-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          width="24"
          height="24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="text-indigo-400"
        >
          <polygon points="32,4 56,18 56,46 32,60 8,46 8,18" strokeLinejoin="round" />
          <circle cx="32" cy="32" r="6" />
          <line x1="32" y1="26" x2="32" y2="12" strokeLinecap="round" />
          <line x1="38" y1="32" x2="50" y2="32" strokeLinecap="round" />
          <line x1="32" y1="38" x2="32" y2="52" strokeLinecap="round" />
          <line x1="26" y1="32" x2="14" y2="32" strokeLinecap="round" />
          <circle cx="32" cy="12" r="1.5" fill="currentColor" />
          <circle cx="32" cy="52" r="1.5" fill="currentColor" />
          <circle cx="14" cy="32" r="1.5" fill="currentColor" />
          <circle cx="50" cy="32" r="1.5" fill="currentColor" />
        </svg>
        <span className="text-white text-lg font-semibold tracking-wide" onClick={routeTohome}>SelficAI</span>
      </div>

      {/* User Menu */}
      <div className="relative">
        <button
          onClick={() => setOpen(!open)}
          className="flex items-center gap-2 text-sm text-gray-300 hover:text-white focus:outline-none"
        >
          {/* User Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5 text-gray-300"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.6}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M16 21v-2a4 4 0 0 0-8 0v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          {getUserFullName()}
          <svg
            className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''
              }`}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {/* Dropdown */}
        {open && (
          <div className="absolute right-0 mt-2 w-44 bg-neutral-800 border border-neutral-700 rounded-md shadow-xl z-50">
            <a
              href="#"
              className="flex items-center gap-2 px-4 py-2 text-sm text-gray-200 hover:bg-neutral-700"
            >
              <UserCircle className="w-4 h-4" /> My Profile
            </a>
            <a
              href="#"
              className="flex items-center gap-2 px-4 py-2 text-sm text-gray-200 hover:bg-neutral-700"
            >
              <Settings className="w-4 h-4" /> Settings
            </a>
            <a onClick={routeToLogin}
              className="flex items-center gap-2 px-4 py-2 text-sm text-red-400 hover:bg-neutral-700"
            >
              <LogOut className="w-4 h-4" /> Logout
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
